import router from './router'
import store from './store'
import getPageTitle from '@/utils/get-page-title'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style

NProgress.configure({ showSpinner: false }) // NProgress Configuration
// 白名单
const whiteList = [
  '/dc/admin/login',
  '/dc/admin/skip',
  '/dc/admin/skip',
  '/business/inspect/healthPad',
  '/404',
  '/business/treatment/wenzhen'
]

// 路由器前置过滤器，权限处理
router.beforeEach(
  async(to, from, next) => {
    // 进度条开始
    NProgress.start()
    // 获取并修改页面标题
    document.title = getPageTitle(to.meta.title)
    // 获取token
    const token = store.getters['user/getToken']

    if (token) {
      /* 如果存在token */
      if (to.path === '/dc/admin/login') {
        // 已登录时访问登录页，直接跳转到目标页或首页
        const redirectPath = to.query.url || to.query.redirect || '/'
        next({ path: redirectPath })
        NProgress.done()
      } else {
        const userName = store.getters['user/getUserName']
        if (userName) {
          next()
        } else {
          try {
            next()
          } catch (error) {
            Message.error(error || 'Has Error')
            next(`/dc/admin/login?redirect=${to.path}`)
            NProgress.done()
          }
        }
      }
    } else {
      /* 没有token信息 */
      if (to.path === '/dc/admin/login' && to.query.usercode && to.query.password) {
        // 携带自动登录参数时，直接重定向到跳转页，避免显示登录界面
        next({
          path: '/dc/admin/skip',
          query: to.query,
          replace: true
        })
        NProgress.done()
      } else if (whiteList.indexOf(to.path) !== -1) {
        // 如果访问白名单信息，允许访问
        next()
      } else {
        // 如果访问非白名单信息，跳转到登录页面。原地址作为redirect参数
        next(`/dc/admin/login?redirect=${to.path}`)
        NProgress.done()
      }
    }
  }
)

// 路由器后置过滤器
router.afterEach(() => {
  // 进度条结束
  NProgress.done()
})
